import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { rem } from "polished";
import React from "react";

import { Flex } from "../../base";
import { AmpTiny } from "../Icons";
import TokenInput from "../TokenInput";

const Container = (props) => (
  <Flex
    between
    borderRadius={8}
    css={css`
      position: relative;
      max-width: ${rem(200)};
      overflow: hidden;
      border: 1px solid #ccc;
    `}
    {...props}
  />
);

const BlankInput = styled.input`
  outline: none;
  border: none;
`;

const Input = styled(BlankInput)`
  max-width: 100%;
  font-size: ${rem(24)};
  text-align: right;
  padding: ${rem(10)} ${rem(26)} ${rem(10)} ${rem(10)};
`;

const SliderInput = (props) => (
  <Container>
    <TokenInput customInput={Input} {...props} />
    <div
      css={css`
        position: absolute;
        right: ${rem(8)};
      `}
    >
      <AmpTiny
        color="rgba(0, 0, 0, 0.2)"
        css={css`
          position: relative;
          top: ${rem(2)};
          width: ${rem(15)};
          height: ${rem(15)};
        `}
      />
    </div>
  </Container>
);

export default SliderInput;
